import { Link } from 'react-router-dom';

const services = [
  { label: 'Estate Planning', to: '/EstatePlanning' },
  { label: 'Health Insurance', to: '/HealthInsurance' },
  { label: 'Life Insurance', to: '/LifeInsurance' },
  { label: 'Annuities', to: '/Annuities' },
  { label: 'Notary In Person', to: '/NotaryPerson' },
  { label: 'Notary Remote Online', to: '/NotaryRemote' },
  { label: 'Retirement Planning', to: '/RetirementPlanning' },
  { label: 'Tax Optimization', to: '/TaxOptimization' },
  { label: 'Expert 401K Rollover', to: '/ExpertRollovers' },
  { label: 'Debt Management', to: '/DebtManagement' },
  { label: 'Wealth Management', to: '/WealthManagement' },
  { label: 'Business Opportunity', to: '/BusinessOpportunity' },
];

function ServiceNav({ activePath }) {
  return (
    <div className="tp-service-widget-tab">
      <h3 className="tp-service-widget-title">Our service</h3>
      <ul>
        {services.map(({ label, to }) => (
          <li key={to} className={activePath === to ? 'active' : ''}>
            <Link to={to}>{label}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default ServiceNav;